import { all } from 'redux-saga/effects';
import authSagas from './auth.saga';
import masterSagas from './master_data.saga';
import contentSagas from './contents.saga';
import healthPartnerSagas from './health_partners.saga';
import userSagas from './users.saga';
import patientSagas from './patients.saga';
import doctorsSagas from './doctors.saga';
import doctorSmsSaga from './doctor.sms.saga';
import SubscriptionsSagas from './subscriptions.saga';
import featuresSagas from './features.saga';
import packagesSagas from './packs.saga';
import businessSagas from './businesses.saga';
import promotionsagas from './promotions.saga';
import consultationsagas from './consultations.saga';
import paymentsagas from './payment.saga';
import doctorShiftSagas from "./doctorShift.saga";
import shiftCategorySagas from "./shiftCategories.saga";
import activeDoctorShifts from "./doctorActiveShift.saga";
import doctorLeaveSaga from "./doctorLeave.saga";
import tanentSaga from "./tanent.saga";
import schedularSaga from "./schedular.saga";
import newConsultaion from "./new.consultaion.saga";
import paymentTypes from "./paymentType.saga";

import axios from "axios";
import { authToken, chatToken } from "util/gen3token";
require("dotenv").config();

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    masterSagas(),
    contentSagas(),
    healthPartnerSagas(),
    userSagas(),
    patientSagas(),
    doctorsSagas(),
    doctorSmsSaga(),
    SubscriptionsSagas(),
    featuresSagas(),
    packagesSagas(),
    businessSagas(),
    promotionsagas(),
    consultationsagas(),
    paymentsagas(),
    doctorShiftSagas(),
    shiftCategorySagas(),
    activeDoctorShifts(),
    doctorLeaveSaga(),
    tanentSaga(),
    schedularSaga(),
    newConsultaion(),
    paymentTypes()
  ]);
}

export const authInstanceWithoutHeaders = axios.create({
  baseURL: process.env.REACT_APP_AUTH_HOST
});
 
export const authinstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_HOST,
  headers: {
    Authorization: `${authToken()}`,
  },
});
 
export const chatInstance = axios.create({
  baseURL: process.env.REACT_APP_CHAT_HOST || "http://localhost:7000/chat",
  headers: {
    Authorization: `token ${chatToken()}`,
  },
});

axios.defaults.baseURL = process.env.REACT_APP_MAIN_BACKEND_HOST;
axios.defaults.headers.common["Authorization"] = `${authToken()}`;
